import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, createElementBlock as _createElementBlock, unref as _unref } from "vue"

const _hoisted_1 = { class: "main" }

import { computed, onMounted, reactive, watch } from 'vue';
  import { useRoute, useRouter } from 'vue-router';
  import { useAuthStore } from '@/stores/AuthStore';
  import { useUserStore } from '@/stores/UserStore';
  import Header from '@/components/Layout/AppHeader.vue';
  import Footer from '@/components/Layout/AppFooter.vue';
  import Navigation from '@/components/Layout/NavigationBar.vue';
  import MediaLibraryDrawer from './components/MediaLibraryDrawer.vue';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

  const authStore = useAuthStore();
  const userStore = useUserStore();
  const route = useRoute();
  const router = useRouter();

  const state = reactive({ actionsEnabled: false });
  const loggedIn = computed(() => !!userStore.currentUser);
  const userIsLoading = computed(() => userStore.isLoading);

  onMounted(() => {
    userStore.getCurrentUser().catch(() => {
      authStore.clearUserToken();
      router.push({ name: 'login' });
    });
  });

  watch(
    route,
    (value) => {
      switch (value.name) {
        case 'sites/create':
        case 'pages/create':
        case 'template/builder':
          state.actionsEnabled = true;
          break;
        default:
          state.actionsEnabled = false;
      }
    },
    {
      deep: true,
    }
  );

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!userIsLoading.value && loggedIn.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(Header),
          (state.actionsEnabled)
            ? (_openBlock(), _createBlock(Navigation, { key: 0 }))
            : _createCommentVNode("", true),
          _createVNode(_component_router_view),
          _createVNode(Footer),
          _createVNode(MediaLibraryDrawer)
        ], 64))
      : _createCommentVNode("", true),
    (_unref(route).name === 'login')
      ? (_openBlock(), _createBlock(_component_router_view, { key: 1 }))
      : _createCommentVNode("", true)
  ]))
}
}

})